import { createStore, applyMiddleware, compose } from 'redux';
import ReduxPromise from 'redux-promise';
import { createEpicMiddleware } from 'redux-observable';
import { authToken, teladocApi } from '@td/api';

/* eslint-disable import/no-extraneous-dependencies */
import logger from 'redux-logger';
/* eslint-enable */

import reducers from '../reducers';
import epics from '../epics';

const epicMiddleware = createEpicMiddleware({dependencies: {token: authToken.get(), teladocApi}});
const createMiddlewareStore = applyMiddleware(ReduxPromise)(createStore);
let store;

if (process.env.NODE_ENV === 'production') {
  store = createMiddlewareStore(reducers,
    applyMiddleware(ReduxPromise, epicMiddleware));
} else {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const haveLog = window.console && console.log; // eslint-disable-line no-console

  if (haveLog) {
    // eslint-disable-next-line no-console
    console.log('Non-production mode: enabling reduxTools');
  }

  store = createStore(reducers,
    composeEnhancers(
      applyMiddleware(ReduxPromise, epicMiddleware, logger)
  ));
}

epicMiddleware.run(epics);

export default store;
